<template lang="pug">
  dx-popup(ref="NoticiasPopup" :width="ancho" :height="alto" :show-close-button="false" :show-title="false")
    div(style="display: flex")
      h2.dx-field(style="font-size: 1.5em; padding: 10px;") {{ titulo }}
      div(style="margin-left: auto;")
      dx-button(@click="cerrar" icon="close" styling-mode="text")
    div(id="contenidoHTML" style="height: 100%; width: 100%" v-html="contenidoHTML")
</template>
<script>
export default {
  data: () => ({
    titulo: "",
    ancho: 0,
    alto: 0,
    contenidoHTML: ""
  }),
  methods: {
    cerrar() {
      this.$refs.NoticiasPopup.instance.hide();
    },
    show(noticia) {
      if (noticia) {
        this.titulo = noticia.titulo;
        this.ancho = noticia.ancho;
        this.alto = noticia.alto;
        if (window.innerWidth < noticia.ancho) {
          this.ancho = "100%";
        }
        this.contenidoHTML = noticia.contenidoHTML;
      }
      this.$refs.NoticiasPopup.instance.repaint();
      this.$refs.NoticiasPopup.instance.show();
      let con = document.getElementById("contenidoHTML");
      if (con && this.ancho == "100%") {
        this.alto = "auto";
      }
    }
  }
};
</script>
